import React, { useRef } from "react";
import { withRouter } from "react-router";
import { useState, useEffect } from "react";

import "./index.scss";

const BlankFrame = ({ url }) => {
  const size = useWindowSize();
  const iframeRef = useRef();

  let divWidth = size.width - 0 - 25;
  let divMarginBottom = 0;
  if (size.width >= 768) {
    divMarginBottom = 40;
  }

  return (
    <div
      ref={iframeRef}
      style={{
        overflow: "auto",
        width: divWidth,
        marginBottom: divMarginBottom,
      }}
    >
    </div>
  );
};

function useWindowSize() {
  const isClient = typeof window === "object";

  function getSize() {
    return {
      width: isClient ? window.innerWidth : undefined,
      height: isClient ? window.innerHeight : undefined,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {
      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
  });

  return windowSize;
}

export default withRouter(BlankFrame);
